import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

interface MergeContactsData {
  ghostProfileId: string
  realContactAccountId: string
}

interface MergeContactsResponse {
  success: boolean
}

const mergeContacts = async (data: MergeContactsData): Promise<MergeContactsResponse> => {
  const { data: response } = await api.post<MergeContactsResponse>('/ft_merge-contacts', data)
  return response
}

export const useFtMergeContacts = () => {
  const queryClient = useQueryClient()

  return useMutation<MergeContactsResponse, Error, MergeContactsData>({
    mutationFn: mergeContacts,
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['ft-merge-suggestions'] }),
        queryClient.invalidateQueries({ queryKey: ['contacts'] }),
        queryClient.invalidateQueries({ queryKey: ['contacts-suggested'] }),
      ])
    },
  })
}
